import React from 'react';
import type { Control } from 'react-hook-form';
import styles from './styles.module.scss';
import { AppNumberInput, AppTextInput, AppToggleInput } from '../../../formFields';
import { constructClassName } from '../../../../utils/constructClassName';
import { toSentenceCase } from '../../../../utils/changeCase';

interface Props {
  control: Control;
  currentQuestionIndex: number,
  question: {
    type: string,
    question: string,
    index: number,
    options?: string[],
  }
  type: string;
  handleNext?: () => void;
}

export const RenderFields: React.FC<Props> = ({
  control,
  currentQuestionIndex,
  question,
  type,
  handleNext,
}) => {
  switch (type) {
    case 'TEXT':
      return (
        <AppTextInput
          classNames={{
            label: styles.label,
          }}
          control={control}
          name={question?.question.replace(/[^a-zA-Z0-9 ]/g, '')}
          label={question?.question}
          required={currentQuestionIndex >= question.index}
        />
      );
    case 'NUMBER':
      return (
        <AppNumberInput
          classNames={{
            input: constructClassName([
              // TODO: investigate this styles
              // sharedStyles.input,
              styles.numberInput]),
            label: styles.label,
          }}
          control={control}
          name={question?.question.replace(/[^a-zA-Z0-9 ]/g, '')}
          label={question?.question}
          type="number"
          min="0"
          required={currentQuestionIndex >= question.index}
        />
      );
    case 'RADIO':
      return (
        <React.Fragment>
          <AppToggleInput
            classNames={{
              label: styles.label,
              toggleOptionLabel: styles.toggleOptionLabel,
            }}
            control={control}
            name={question?.question.replace(/[^a-zA-Z0-9 ]/g, '')}
            label={question?.question}
            options={(question?.options ?? []).map((option) => ({
              label: option,
              value: option,
            }))}
            onChange={handleNext}
            required={currentQuestionIndex >= question.index}
          />
        </React.Fragment>

      );
    default:
      return null;
  }
};
